import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import { selectModalBulkUpdateField, selectModalBulkUpdateValue } from 'store/ManageGeneral/selectors';
import { setBulkUpdateValue } from 'store/ManageGeneral/actions';

const BulkMarkdownEditor = () => {
  const dispatch = useDispatch();
  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);

  return (
    <MarkdownEditor
      title={ bulkUpdateField }
      onBlur={ (value) => dispatch(setBulkUpdateValue(value)) }
      value={ bulkUpdateValue }
    />
  );
};

export default BulkMarkdownEditor;
